export const jobWorkplaceTypesSk = {
  jobWorkplaceTypes: {
    any: 'Nezáleží',
    office: 'Práca na pracovisku',
    home: 'Práca z domu',
    mix: 'Čiastočná práca z domu',
    travel: 'Práca s cestovaním',
  },
};
